<app-side-nav mode="bridge" (currencyChange)="onCurrencyChanged($event)"></app-side-nav>
<div class="p-4 max-w-xl mx-auto">
  <!-- 🔳 Backplate plein-bleed derrière le header (mobile only) -->
  <div class="md:hidden fixed top-0 left-0 right-0 z-40"
       [style.height.px]="headerHpx || 72"
       [ngClass]="!isDarkMode() ? 'bg-white' : 'bg-[#111827]'">
  </div>


  <!-- 📱 Mobile Header – version premium (light only) -->
  <div class="md:hidden fixed top-0 left-0 right-0 z-50 px-4 pt-[env(safe-area-inset-top)]">
    <div #mobileHeader
         class="max-w-md mx-auto rounded-2xl p-4 border transition-all backdrop-blur-md shadow-md"
         [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f] border-indigo-500/10'
         : 'bg-gradient-to-b from-blue-50 to-indigo-50 border-indigo-100 shadow-[0_6px_24px_rgba(31,78,255,0.06)]'">

      <!-- Ligne 1 : Titre -->
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-6 h-6 md:w-7 md:h-7" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <h1 class="text-lg font-extrabold tracking-tight text-blue-600 drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]">
          SwapTokens.app
        </h1>
      </div>

      <!-- Ligne 2 : Wallet + Thème -->
      <div class="flex items-center justify-between px-1">
        <!-- Wallet (MOBILE) -->
        <app-connect-wallet-legacy #legacyConnect (connected)="onLegacyConnected($event,'ux')"
                                   (disconnected)="onLegacyDisconnected()" [takerAddress]="takerAddress"
                                   [addLog]="onChildLogConsole" [dark]="isDarkMode()">
        </app-connect-wallet-legacy>


        <!-- Theme -->
        <button (click)="toggleTheme()"
                class="flex items-center justify-center px-3 py-1 rounded-full border transition"
                [ngClass]="isDarkMode()
                ? 'border-white/10 bg-blue-400/10'
                : 'border-indigo-200 bg-white/80 hover:bg-white'">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5 text-blue-300" fill="none"
               stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>


  <!-- Spacer mobile auto (UN SEUL) -->
  <div class="md:hidden" [style.height.px]="headerHpx || 72"></div>

  <!-- 🔵 Bloc Header Visuel Harmonisé – version premium (light only) -->
  <div class="hidden md:block relative mb-4 rounded-2xl overflow-hidden">
    <!-- Carte visible -->
    <div class="relative rounded-2xl p-4 border transition-all backdrop-blur-md hover:border-indigo-400/20"
         [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 shadow-md dark:shadow-purple-900/10'
         : 'bg-gradient-to-b from-blue-50 to-indigo-50 border-indigo-100 shadow-[0_6px_24px_rgba(31,78,255,0.06)]'">

      <!-- 🔹 Ligne Logo + Wallet -->
      <div class="flex justify-between items-center gap-4 mb-3">
        <div class="flex items-center gap-2">
          <svg class="w-6 h-6 md:w-7 md:h-7" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>

          <!-- Titre avec gradient différent en light -->
          <h1 class="text-base sm:text-lg md:text-2xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r " [ngClass]="invBridgeGradient">
            SwapTokens.app
          </h1>
        </div>

        <!-- Wallet (DESKTOP) -->
        <app-connect-wallet-legacy #legacyConnect (connected)="onLegacyConnected($event,'ux')"
                                   (disconnected)="onLegacyDisconnected()" [takerAddress]="takerAddress"
                                   [addLog]="onChildLogConsole" [dark]="isDarkMode()">
        </app-connect-wallet-legacy>

      </div>

      <!-- Bouton thème (mobile only, on garde ton comportement) -->
      <div class="md:hidden flex justify-end">
        <button (click)="toggleTheme()"
                class="p-1 rounded-full transition focus:outline-none focus:ring-0">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5" fill="none" stroke="#a3bffa" stroke-width="2"
               viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-5 h-5" fill="none" stroke="#7c8cfb" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>


  <div class="rounded-2xl p-3 border shadow-md transition-all backdrop-blur-md mb-1 -mt-2"
       [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10' : 'bg-gradient-to-b from-blue-50 to-indigo-50 border-indigo-100 shadow-[0_6px_24px_rgba(31,78,255,0.06)]'">
    <div>

      <!-- 🔹 Cas 1 : SEO dispo -->
      <ng-container *ngIf="tBase; else compareDefault">
        <div class="w-full px-4 py-3 rounded-2xl shadow-md backdrop-blur-md border text-center
              bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 text-white"
             [ngClass]="isDarkMode() ? 'border-indigo-400/20' : 'border-indigo-500/10 shadow-xl'">

          <!-- SEO Titre -->
          <div class="text-[11px] md:text-sm font-semibold leading-snug">
            {{ ((tBase + '.H1') | translate) || editorialH1 }}
          </div>

          <!-- SEO Body -->
          <div class="mt-1 text-[10px] md:text-xs opacity-90 font-normal">
            {{ ((tBase + '.EDITORIAL') | translate) || editorialBody }}
          </div>
        </div>
      </ng-container>

      <!-- 🔹 Cas 2 : Pas de SEO → fallback compare exchanges -->
      <ng-template #compareDefault>
        <div class="w-full px-4 py-3 rounded-2xl shadow-md backdrop-blur-md border text-center
              bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 text-white"
             [ngClass]="isDarkMode() ? 'border-indigo-400/20' : 'border-indigo-500/10 shadow-xl'">

          <div class="text-sm md:text-lg font-semibold leading-snug">
            <span class="
       text-[10px] md:text-xs font-semibold uppercase tracking-[.16em]
       px-2 py-0.5 rounded-full bg-white/10 backdrop-blur
       border border-white/15 shadow-[0_1px_2px_rgba(0,0,0,.12)]
       select-none mb-6">
              Bridge
            </span>
          </div>

          <div class="text-[11px] md:text-sm font-semibold leading-snug mt-1">
            {{ 'COMPARE_EXCHANGES' | translate }}
          </div>

          <div class="mt-1 text-[10px] md:text-xs opacity-90 font-normal">
            {{ 'BRIDGE_COMPARE_EXCHANGES_DETAILS' | translate }}
          </div>
        </div>
      </ng-template>


      <!-- Ligne titre + sélecteur -->
      <div class="flex justify-between items-center mt-4">
        <!-- Titre SELL_AMOUNT -->
        <h3 class="flex items-center gap-2 text-[11px] md:text-xs font-semibold uppercase tracking-[.12em]"
            [ngClass]="isDarkMode() ? 'text-white/85' : 'text-blue-900/80'">
          <!-- puce dégradée, thème bridge (blue → indigo) -->
          <svg class="w-2.5 h-2.5 rounded-full" viewBox="0 0 10 10" fill="none" aria-hidden="true">
            <circle cx="5" cy="5" r="5" class="fill-[url(#gb-sell)]" />
            <defs>
              <linearGradient id="gb-sell" x1="0" y1="0" x2="10" y2="10">
                <stop offset="0" stop-color="#3B82F6" />  <!-- blue-500 -->
                <stop offset="1" stop-color="#6366F1" />  <!-- indigo-500 -->
              </linearGradient>
            </defs>
          </svg>
          {{ 'SELL_AMOUNT' | translate }}
        </h3>


        <!-- 🌐 Sélecteur Réseau – style “libellé” (Swap-like) -->
        <div class="relative h-7 flex items-center">
          <button type="button"
                  #chainTrigger
                  (click)="$event.stopPropagation(); showChainMenu = !showChainMenu"
                  aria-haspopup="listbox"
                  class="inline-flex items-center gap-2 h-7 px-1.5 rounded-md
                 text-[11px] md:text-xs font-medium uppercase tracking-[.12em]
                 transition-colors"
                  [ngClass]="isDarkMode()
            ? 'text-white/80 hover:text-white'
            : 'text-blue-900/80 hover:text-blue-900'">
            <!-- puce bleue -->
            <span class="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500"></span>

            <!-- icône réseau (disque blanc si Ethereum) -->
            <span class="relative inline-flex items-center justify-center w-5 h-5 rounded-full"
                  [ngClass]="(chainId || 1) === 1
            ? (isDarkMode() ? 'bg-white ring-1 ring-white/10' : 'bg-white')
            : 'bg-transparent'">
              <img [src]="CHAIN_MAP[chainId || 1]?.icon"
                   class="w-3.5 h-3.5 rounded-full object-contain" />
            </span>

            <!-- nom réseau -->
            <span class="whitespace-nowrap">{{ CHAIN_MAP[chainId || 1]?.name }}</span>

            <!-- chevron -->
            <svg class="w-3 h-3 opacity-70"
                 [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-500'"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
            </svg>
          </button>

          <!-- Dropdown réseaux -->
          <ul *ngIf="showChainMenu"
              #chainMenuRoot
              class="absolute top-full right-0 mt-1 w-[max(128px,100%)] rounded-xl border z-30 overflow-hidden text-xs shadow-xl"
              role="listbox"
              [ngClass]="isDarkMode()
        ? 'bg-gray-900 border-blue-700/70 text-white'
        : 'bg-white border-gray-200 text-gray-800'">
            <li *ngFor="let id of [1,137,42161,56]"
                role="option"
                [attr.aria-selected]="(selectedNetwork || 1) === id"
                (click)="changeChain(id); showChainMenu = false"
                class="px-2 py-1.5 cursor-pointer flex items-center justify-between gap-2 transition-colors"
                [ngClass]="(selectedNetwork || 1) === id
          ? (isDarkMode() ? 'bg-blue-600/15' : 'bg-indigo-50')
          : (isDarkMode() ? 'hover:bg-blue-600/10' : 'hover:bg-indigo-50')">
              <div class="flex items-center gap-2">
                <img [src]="CHAIN_MAP[id].icon" class="w-4 h-4 rounded-full" />
                <span class="whitespace-nowrap text-[11px] tracking-[.02em]">
                  {{ CHAIN_MAP[id].name }}
                </span>
              </div>

              <!-- check sélection -->
              <svg *ngIf="(chainId || 1) === id" class="w-3.5 h-3.5"
                   [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-600'"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </li>
          </ul>
        </div>

      </div>

      <!-- Séparateur premium (light only) -->
      <div [ngClass]="isDarkMode()
  ? 'mt-2 md:mt-3'
  : 'mt-2 md:mt-3 border-t border-indigo-100/60'"></div>


      <!-- Montant à vendre -->
      <div class="relative">
        <input type="text" appFocusScrollGuard appDecimalCommaFix
               [commaFixLog]="addLog.bind(this)"
               inputmode="decimal"
               step="any"
               autocomplete="off"
               autocorrect="off"
               enterkeyhint="done"
               class="w-full h-13 px-4 pr-24 rounded-2xl transition-all
        font-medium leading-tight [font-variant-numeric:tabular-nums]
               text-[17px] md:text-base
         shadow-[0_2px_10px_rgba(31,78,255,0.06)]
         focus:outline-none"
               [ngClass]="isDarkMode()
    ? 'border border-blue-600 bg-gray-800 text-white focus:border-blue-500 focus:ring-2 focus:ring-blue-500/40'
    : 'border border-indigo-200 bg-white/95 text-gray-900 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-300'"
               [(ngModel)]="sellAmount"
               placeholder="0" />


        <!-- Fiat équivalent (skeleton pendant chargement des taux) -->
        <!--<div class="absolute top-1 right-4 text-[10px] md:text-xs"
             [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-700'">
          <ng-container *ngIf="!fiatLoading && getSellFiatValue(); else fiatSkel">
         
          </ng-container>
          <ng-template #fiatSkel>
            <span class="inline-block align-middle w-16 h-3 rounded
            bg-slate-200/50 dark:bg-slate-700/40 animate-pulse"></span>
          </ng-template>
        </div>-->


      </div>


      <!-- Sélecteur Token à vendre -->
      <div class="mt-2 md:mt-4">
        <button type="button"
                (click)="showTokenModal = true"
                class="w-full flex items-center justify-between px-4 py-3 rounded-2xl transition shadow-sm"
                [ngClass]="isDarkMode()
      ? 'border border-blue-600 bg-gray-800'
      : 'border border-indigo-200 bg-white/95 shadow-[0_2px_10px_rgba(31,78,255,0.06)]'">

          <div class="flex items-center gap-2" [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-900'">
            <img [src]="getTokenLogo(sellTokenSymbol)"
                 class="w-5 h-5 md:w-6 md:h-6 rounded-full"
                 decoding="async" fetchpriority="high" />
            <span class="font-normal leading-tight text-[11px] md:text-sm"
                  [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-900'">
              {{ getTokenLabel(sellTokenSymbol) }}
            </span>
          </div>

          <span class="text-[10px] md:text-xs" [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-700'">
            <ng-container *ngIf="!balancesLoading


                          ; else balSellSkel">
              {{ getTokenBalance(sellTokenSymbol) }}
            </ng-container>
            <ng-template #balSellSkel>
              <span class="inline-block align-middle w-14 h-3 rounded
          bg-slate-200/50 dark:bg-slate-700/40 animate-pulse"></span>
            </ng-template>
          </span>

        </button>
      </div>




      <!-- Ligne titre + sélecteur -->
      <div class="flex justify-between items-center mt-4">
        <h3 class="flex items-center gap-2 text-[11px] md:text-xs font-semibold uppercase tracking-[.12em]"
            [ngClass]="isDarkMode() ? 'text-white/85' : 'text-blue-900/80'">
          <!-- puce dégradée (blue → indigo) -->
          <svg class="w-2.5 h-2.5 rounded-full" viewBox="0 0 10 10" fill="none" aria-hidden="true">
            <circle cx="5" cy="5" r="5" class="fill-[url(#gb-buy)]" />
            <defs>
              <linearGradient id="gb-buy" x1="0" y1="0" x2="10" y2="10">
                <stop offset="0" stop-color="#3B82F6" />  <!-- blue-500 -->
                <stop offset="1" stop-color="#6366F1" />  <!-- indigo-500 -->
              </linearGradient>
            </defs>
          </svg>
          {{ 'BUY_TOKEN' | translate }}
        </h3>


        <!-- 🌐 Sélecteur Réseau – style “libellé” (Swap-like) -->
        <div class="relative h-7 flex items-center">
          <button type="button"
                  (click)="$event.stopPropagation(); showNetworkBuyDropdown = !showNetworkBuyDropdown"
                  aria-haspopup="listbox"
                  [attr.aria-expanded]="showNetworkBuyDropdown"
                  class="inline-flex items-center gap-2 h-7 px-1.5 rounded-md
                 text-[11px] md:text-xs font-medium uppercase tracking-[.12em]
                 transition-colors"
                  [ngClass]="isDarkMode()
            ? 'text-white/80 hover:text-white'
            : 'text-blue-900/80 hover:text-blue-900'">
            <!-- puce bleue -->
            <span class="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500"></span>

            <!-- icône réseau (disque blanc si Ethereum) -->
            <span class="relative inline-flex items-center justify-center w-5 h-5 rounded-full"
                  [ngClass]="(buyChainId || 1) === 1
            ? (isDarkMode() ? 'bg-white ring-1 ring-white/10' : 'bg-white')
            : 'bg-transparent'">
              <img [src]="CHAIN_MAP[buyChainId || 1]?.icon"
                   class="w-3.5 h-3.5 rounded-full object-contain" />
            </span>

            <!-- nom réseau -->
            <span class="whitespace-nowrap">{{ CHAIN_MAP[buyChainId || 1]?.name }}</span>

            <!-- chevron -->
            <svg class="w-3 h-3 opacity-70"
                 [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-500'"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
            </svg>
          </button>

          <!-- Dropdown réseaux -->
          <ul *ngIf="showNetworkBuyDropdown"
              class="absolute top-full right-0 mt-1 w-[max(128px,100%)] rounded-xl border z-30 overflow-hidden text-xs shadow-xl"
              role="listbox"
              [ngClass]="isDarkMode()
        ? 'bg-gray-900 border-blue-700/70 text-white'
        : 'bg-white border-gray-200 text-gray-800'">
            <li *ngFor="let id of [1,137,42161,56]"
                role="option"
                (click)="changeBuyChain(id)"
                class="px-2 py-1.5 cursor-pointer flex items-center justify-between gap-2 transition-colors"
                [ngClass]="(selectedBuyNetwork || 1) === id
          ? (isDarkMode() ? 'bg-blue-600/15' : 'bg-indigo-50')
          : (isDarkMode() ? 'hover:bg-blue-600/10' : 'hover:bg-indigo-50')">
              <div class="flex items-center gap-2">
                <img [src]="CHAIN_MAP[id].icon" class="w-4 h-4 rounded-full" />
                <span class="whitespace-nowrap text-[11px] tracking-[.02em]">
                  {{ CHAIN_MAP[id].name }}
                </span>
              </div>
              <svg *ngIf="(buyChainId || 1) === id" class="w-3.5 h-3.5"
                   [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-600'"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </li>
          </ul>
        </div>


      </div>

      <!-- Séparateur premium (light only) -->
      <div [ngClass]="isDarkMode()
  ? 'mt-2 md:mt-3'
  : 'mt-2 md:mt-3 border-t border-indigo-100/60'"></div>


      <!-- Sélecteur Token -->
      <button type="button"
              (click)="showBuyTokenModal = true"
              class="w-full flex items-center justify-between px-4 py-3 rounded-2xl transition shadow-sm"
              [ngClass]="isDarkMode()
    ? 'border border-blue-600 bg-gray-800'
    : 'border border-indigo-200 bg-white/95 shadow-[0_2px_10px_rgba(31,78,255,0.06)]'">
        <div class="flex items-center gap-2">
          <img [src]="getTokenLogo(buyTokenSymbol)"
               class="w-5 h-5 md:w-6 md:h-6 rounded-full"
               width="24" height="24" decoding="async" fetchpriority="high" />

          <span class="font-normal leading-tight text-[11px] md:text-sm"
                [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-900'">
            {{ getTokenLabel(buyTokenSymbol) }}
          </span>
        </div>
      </button>


    </div>
  </div>
  <!-- 🔄 Bouton Obtenir le meilleur taux (Bridge, style aligné sur Swap) -->
  <button class="w-full py-4 rounded-xl font-medium text-white
         text-[11px] md:text-[13px]
         shadow-md hover:brightness-110 active:scale-[.99]
         transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30
         disabled:opacity-60 disabled:cursor-not-allowed
         bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600"
          [disabled]="isLoadingQuote || !sellAmount || !sellTokenSymbol || !buyTokenSymbol"
          (click)="fetchBridgeQuote()"
          type="button"
          style="background-color: transparent;">
    <ng-container *ngIf="!isLoadingQuote; else loading">
      {{ 'GET_BEST_RATE' | translate }}
    </ng-container>
    <ng-template #loading>
      <svg class="animate-spin h-5 w-5 mx-auto text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </ng-template>
  </button>



  <div class="flex flex-col gap-4 -mt-3 md:-mt-2">





    <!-- Debug panel -->
    <div *ngIf="showDebug"
         class="fixed left-3 right-3 bottom-14 z-[9998] p-3 rounded-lg border bg-black/80 text-xs text-white overflow-auto"
         [style.maxHeight.px]="isDebugCollapsed ? 40 : 256">

      <div class="flex justify-between items-center mb-1">
        <div class="flex items-center gap-2">
          <span class="font-semibold">Debug Connect</span>
          <button (click)="isDebugCollapsed = !isDebugCollapsed"
                  class="px-2 py-0.5 bg-gray-700 text-white rounded text-xs hover:bg-gray-600 active:bg-gray-800">
            {{ isDebugCollapsed ? '▼' : '▲' }}
          </button>
        </div>
        <button (click)="copyDebugLogs()"
                class="px-2 py-1 bg-indigo-500 text-white rounded text-xs hover:bg-indigo-600 active:bg-indigo-700">
          📋 Copier
        </button>
      </div>

      <pre *ngIf="!isDebugCollapsed" style="white-space: pre-wrap">{{ debugText }}</pre>
    </div>






    <!-- 🔴 Erreur quote -->
    <div *ngIf="quoteErrorMessage"
         class="flex flex-col md:flex-row md:items-start gap-3 md:gap-4 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-xl p-3 mt-3"
         role="status" aria-live="polite">

      <div class="flex items-start gap-3">
        <svg class="w-5 h-5 mt-0.5 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="9" stroke-width="2" />
          <path d="M12 8h.01M11.5 11.5h1v5h-1z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <div class="flex-1">
          <div class="font-medium">{{ 'QUOTE_UNAVAILABLE_TITLE' | translate }}</div>
          <p class="mt-0.5">{{ 'QUOTE_UNAVAILABLE_BODY' | translate }}</p>
        </div>
      </div>

      <button type="button"
              class="w-full md:w-auto md:ml-auto px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-white shrink-0 text-center"
              (click)="fetchBridgeQuote()">
        {{ 'RETRY' | translate }}
      </button>
    </div>

    <!-- 📦 Aperçu quote (V2) -->
    <!-- 📦 Aperçu quote (V2, sans régression) -->
    <div *ngIf="quote"
         class="fixed inset-0 z-[9990] bg-black/60 backdrop-blur-sm overflow-y-auto"
         role="dialog" aria-modal="true" tabindex="0"
         style="
  padding-top:    max(env(safe-area-inset-top),    12px);
  /* un peu plus d’air en bas pour le sticky */
  padding-bottom: calc(max(env(safe-area-inset-bottom), 16px) + 24px);
  /* ↑ marges extérieures visuelles plus larges */
  padding-left:   max(env(safe-area-inset-left),   20px);
  padding-right:  max(env(safe-area-inset-right),  20px);
 "
         (click)="closeQuote()"
         (keydown.escape)="closeQuote()">
      <!-- stop propagation pour éviter de fermer en cliquant dans la carte -->
      <div class="min-h-full flex items-start md:items-center justify-center"
           (click)="$event.stopPropagation()">
        <div class="w-full md:max-w-2xl">
          <app-bridge-quote-preview-v2 [quote]="quote"
                                       [buyTokenSymbol]="buyTokenSymbol"
                                       [otherRoutes]="quote?.singleRoutes || quote?.SingleRoutes || []"
                                       [nativeBalanceWei]="currentNativeBalanceWei"
                                       [outTokenPriceUSD]="outTokenPriceUSD"
                                       [gasFeePriceUSD]="gasFeePriceUSD"
                                       [inTokenPriceUSD]="inTokenPriceUSD"
                                       (requestConnect)="onQuoteRequestConnect()"
                                       [fiatRates]="fiatRates"
                                       [selectedCurrency]="defaultFiat"
                                       [takerAddress]="takerAddress"
                                       [chainId]="chainId"
                                       [sellTokenSymbol]="sellTokenSymbol"
                                       [sellAmount]="sellAmount"
                                       [bridgeStatus]="bridgeStatus"
                                       [bypassDebug]="debugBypassGasCheck"
                                       [bridgeHash]="bridgeHash"
                                       [bridgeError]="bridgeError"
                                       [fullGasWei]="fullGasWei"
                                       [availableSellTokens]="availableTokens"
                                       [sellTokenBalances]="tokenCachedBalances"
                                       [getNativeTokenSymbol]="getNativeTokenSymbol.bind(this)"
                                       (executeRequest)="onClickExecuteBridge()"
                                       (close)="closeQuote();scrollToTop()"
                                       (executeAlt)="onAlternativeSelected($event)">
          </app-bridge-quote-preview-v2>
          <!-- Spacer bas pour créer une marge avec le bord inférieur de l'écran -->
          <div aria-hidden="true"
               class="h-106 md:h-76"
               style="height: calc(env(safe-area-inset-bottom) + 176px)"></div>
        </div>
      </div>
    </div>


    <!-- 📦 Aperçu quote -->
    <!--<app-bridge-quote-preview class="mt-4" *ngIf="quote"
                              [quote]="quote"
                              [fiatRates]="fiatRates"
                              [priceMap]="priceMap"
                              [selectedCurrency]="defaultFiat"
                              [inTokenPriceUSD]="inTokenPriceUSD"
                              [outTokenPriceUSD]="outTokenPriceUSD"
                              [bridgeFeePriceUSD]="bridgeFeePriceUSD"
                              [gasFeePriceUSD]="gasFeePriceUSD"
                              [bridgeDisabled]="bridgeDisabled"
                              [bridgeReasons]="bridgeReasons"
                              [bridgeStatus]="bridgeStatus"
                              [failedAltRouteIds]="failedAltRouteIds"
                              [bridgeHash]="bridgeHash"
                              [bridgeError]="bridgeError"
                              (validateAlternative)="onValidateAlternative($event)"
                              [selectedRouteId]="selectedAltRouteId"
                              (executeRequest)="onExecuteBridgeQuote()"
                              (close)="closeQuote();scrollToTop()"
                              [takerAddress]="takerAddress"
                              [fromChainId]="selectedNetwork ?? chainId ?? 1"
                              [sellTokenSymbol]="sellTokenSymbol"
                              [sellAmount]="sellAmount"
                              [fullGasWei]="fullGasWei"
                              [availableSellTokens]="availableSellTokens"
                              [sellTokenBalances]="sellTokenBalances"
                              [getNativeTokenSymbol]="getNativeTokenSymbol.bind(this)"
                              [marginPct]="0.05">
    </app-bridge-quote-preview>-->
    <!--<div *ngIf="bridgeDisabled && bridgeReasons?.length"
       class="mt-4 rounded-xl border border-blue-200 bg-blue-50 dark:border-blue-500/20 dark:bg-blue-900/20 p-4 space-y-2">

    <div *ngFor="let r of (bridgeReasons.includes('WALLET_DISCONNECTED') ? ['WALLET_DISCONNECTED'] : bridgeReasons)" class="flex items-start gap-2">
      <svg class="w-3 h-3 text-blue-200 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="4" />
      </svg>
      <span class="text-sm text-gray-800 dark:text-gray-200">
        <ng-container [ngSwitch]="r">

          <span *ngSwitchCase="'WALLET_DISCONNECTED'" class="inline-flex items-center gap-2">
            {{ 'BRIDGE_REASON_WALLET_DISCONNECTED' | translate }}

            <button (click)="connectWallet()"
                    class="inline-flex items-center justify-center w-7 h-7 rounded-full
               bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 text-white
               shadow-md hover:brightness-110 transition"
                    aria-label="Connect Wallet">
              <svg viewBox="0 0 24 24" fill="none"
                   stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="w-[18px] h-[18px] flex-shrink-0">
                <path d="M12 3v7" />
                <path d="M6.2 7.8a8 8 0 1 0 11.6 0" />
              </svg>
            </button>
          </span>


          <span *ngSwitchCase="'INVALID_AMOUNT'">
            {{ 'BRIDGE_REASON_INVALID_AMOUNT' | translate }}
          </span>

          <span *ngSwitchCase="'INSUFFICIENT_NATIVE_GAS'">
            {{ 'BRIDGE_REASON_INSUFFICIENT_NATIVE_GAS'| translate:{ symbol: getNativeTokenSymbol(quote?.fromChainId || selectedNetwork || chainId || 1)} }}
          </span>

          <span *ngSwitchCase="'INSUFFICIENT_SELL_TOKEN'">
            {{ 'BRIDGE_REASON_INSUFFICIENT_SELL_TOKEN' | translate:{ token: sellTokenSymbol  } }}
          </span>-->
    <!-- fallback si pas trouvé -->
    <!--<span *ngSwitchDefault>{{ r }}</span>

          </ng-container>
        </span>
      </div>

    </div>-->
    <div class="h-6 sm:h-7"></div>
    <!-- 📊 Stats (sous le CTA) -->
    <!-- 📊 Bridge Stats (blue theme) -->
    <div class="mt-6 space-y-3">

      <!-- 🔵 Tokens -->
      <div class="relative">
        <!-- Glow/ombre colorée -->
        <div class="absolute inset-0 rounded-2xl"
             [ngClass]="isDarkMode()
           ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-blue-600 to-indigo-600 opacity-80'
           : 'bg-gradient-to-r from-blue-300 to-indigo-300 opacity-50 blur-[2px]'">
        </div>

        <div class="relative rounded-2xl px-4 py-3 border shadow-sm transition-all backdrop-blur-md"
             [ngClass]="isDarkMode()
           ? 'bg-[#1e1e2f]/80 border-indigo-500/10'
           : 'bg-white/80 border-indigo-500/10'">
          <div class="flex items-center justify-between">
            <div class="text-[11px] uppercase tracking-wide font-semibold"
                 [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-700'">
              {{ 'STATS.TOKENS.TITLE' | translate }}
            </div>

            <div class="text-xl font-extrabold tracking-wide bg-clip-text text-transparent"
                 [ngClass]="isDarkMode()
               ? 'bg-gradient-to-r from-blue-300 to-indigo-300'
               : 'bg-gradient-to-r from-blue-700 to-indigo-700'">
              2 145+
            </div>
          </div>

          <div class="mt-1 text-sm"
               [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-600'">
            {{ 'STATS.TOKENS.SUBTITLE' | translate }}
          </div>
        </div>
      </div>

      <!-- 🔷 LI.FI numbers -->
      <div class="relative">
        <!-- Glow/ombre colorée -->
        <div class="absolute inset-0 rounded-2xl"
             [ngClass]="isDarkMode()
           ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-indigo-600 to-blue-600 opacity-80'
           : 'bg-gradient-to-r from-indigo-300 to-blue-300 opacity-50 blur-[2px]'">
        </div>

        <div class="relative rounded-2xl px-4 py-3 border shadow-sm transition-all backdrop-blur-md"
             [ngClass]="isDarkMode()
           ? 'bg-[#1e1e2f]/80 border-indigo-500/10'
           : 'bg-white/80 border-indigo-500/10'">
          <div class="flex items-center justify-between">
            <div class="text-[11px] uppercase tracking-wide font-semibold"
                 [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-700'">
              {{ 'STATS.LIFI.TITLE' | translate }}
            </div>

            <div class="text-xl font-extrabold bg-clip-text text-transparent"
                 [ngClass]="isDarkMode()
               ? 'bg-gradient-to-r from-indigo-300 to-blue-300'
               : 'bg-gradient-to-r from-indigo-700 to-blue-700'">
              $30B+
            </div>
          </div>

          <div class="mt-1 text-sm font-semibold bg-clip-text text-transparent"
               [ngClass]="isDarkMode()
             ? 'bg-gradient-to-r from-blue-300 to-indigo-300'
             : 'bg-gradient-to-r from-blue-700 to-indigo-700'">
            {{ 'STATS.LIFI.SECURED' | translate }}
          </div>

          <!-- Badge certifié -->
          <div class="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] font-semibold border shadow-sm"
               [ngClass]="isDarkMode()
             ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-white/10'
             : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-indigo-500/20'">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m5 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{{ 'STATS.LIFI.POWERED' | translate }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>


  <!-- Backdrop (clique dehors => ferme) -->
  <div *ngIf="showFooterMenu"
       class="fixed inset-0 z-[59]"
       (click)="closeFooterMenu()"></div>

  <!-- Sous-menu Info (mobile) -->
  <ul *ngIf="showFooterMenu"
      class="fixed z-[10000] bottom-[72px] left-4 w-[90vw] max-w-xs rounded-2xl shadow-lg border transition-all duration-300 ease-in-out
     backdrop-blur-md backdrop-saturate-150"
      [ngClass]="isDarkMode()
      ? 'bg-gray-900/20 text-white border-white/10'
      : 'bg-white/20 text-gray-800 border-black/10'"
      (click)="$event.stopPropagation()">
    <li>
      <a routerLink="/a-propos"
         (click)="showFooterMenu = false"
         class="block px-4 py-3 rounded-lg border border-transparent hover:border-blue-500 transition duration-200 text-sm font-semibold"
         [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-700'">
        {{ 'ABOUT' | translate }}
      </a>
    </li>

    <li>
      <a routerLink="/disclaimer"
         (click)="showFooterMenu = false"
         class="block px-4 py-3 rounded-lg border border-transparent hover:border-blue-500 transition duration-200 text-sm font-semibold"
         [ngClass]="isDarkMode() ? 'text-blue-300' : 'text-blue-700'">
        {{ 'DISCLAIMER_NAV' | translate }}
      </a>
    </li>
  </ul>
  <app-settings *ngIf="showSettings" class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg"
                (currencyChange)="onCurrencyChanged?.($event)" mode="bridge"></app-settings>

  <div class="md:hidden h-20"></div>
  <app-footer-nav mode="bridge" (settingsClick)="showSettings = !showSettings" (infoClick)="toggleFooterMenu()" [hideOnKeyboard]="false"></app-footer-nav>

</div>

<!-- 🔻 Footer Fixe Mobile -->
<!-- Spacer pour ne pas masquer le contenu par le footer (mobile only) -->
<!--<div class="md:hidden h-20"></div>-->
<!-- Footer type TikTok/X en thème Bridge (bleu) -->
<!--<app-footer-nav mode="bridge"></app-footer-nav>-->
<!-- Wallet-Connect Modal -->
<div *ngIf="showWcModal"
     class="fixed inset-0 flex items-center justify-center bg-black/60 z-[10010]">
  <div class="bg-white dark:bg-gray-800 rounded-xl p-6 w-80 text-center">
    <h2 class="text-lg font-semibold mb-4">{{ 'wc.title' | translate }}</h2>
    <!-- QR code -->
    <img [src]="'https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=' + encodeURIComponent(wcUri)"
         alt="QR WalletConnect" class="mx-auto mb-4" />
    <a [href]="'https://metamask.app.link/wc?uri=' + encodeURIComponent(wcUri)"
       class="inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg">
      {{ 'wc.openInMM' | translate }}
    </a>
    <p class="mt-4 text-xs opacity-70">
      {{ 'wc.hint' | translate }}
    </p>
    <button (click)="closeWcModal()"
            class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
      ✕
    </button>
  </div>
</div>
<app-token-selector [userTokens]="userCachedTokens"
                    [popularTokens]="popularTokens"
                    [tokenBalances]="tokenCachedBalances"
                    [priceMap]="priceMap"
                    [show]="showTokenModal"
                    [dark]="isDarkMode()"
                    mode="bridge"
                    (close)="showTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="selectSellToken($event)"
                    [selectedCurrency]="defaultFiat"
                    [fiatRates]="fiatRates">
</app-token-selector>


<app-token-selector [userTokens]="userBuyCachedTokens"
                    [popularTokens]="popularBuyTokens"
                    [tokenBalances]="buyTokenCachedBalances"
                    [priceMap]="priceBuyMap"
                    [show]="showBuyTokenModal"
                    mode="bridge"
                    [dark]="isDarkMode()"
                    (close)="showBuyTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="selectBuyToken($event)"
                    [selectedCurrency]="defaultFiat"
                    [fiatRates]="fiatRates">
</app-token-selector>


<style>
  ::-webkit-scrollbar {
    display: none;
  }

  .form-control-lg {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    font-size: 1rem;
  }

  select option {
    white-space: pre-line;
  }

  select option {
    white-space: pre-line;
  }

    select option::after {
      content: attr(data-balance);
      display: block;
      font-size: 0.75rem;
      color: #16a34a;
      text-align: right;
    }
</style>
